<template>
  <div class="row" >
    <template v-if="!showCallback">
    <div class="col-sm-12">
      <h4 class="info-text ">
        At Smart Currency Exchange we strive to protect your details for future verification.
        <br/>
        <br/>
        Please enter the 6-digit verification code we sent to your mobile phone
        as a text. {{formData.twoFaMessage}}
      </h4>
      <!-- <p>We want to make sure it's you before proceeding</p> -->
    </div>

    <div class="col-sm-12">
      <div class="code-container">
        <input
          type="text"
          maxLength="6"
          size="6"
          min="0"
          max="9"
          pattern="[0-9]{1}"
          class="input-code"
          name="code"
          v-model.trim="code"
          :class="{ error: errors.has('step2.code') }"
          data-vv-scope="step2"
          v-validate="'required'"
        />
      </div>
    </div>
    <div class="col-sm-12 mt-2">
    <privacy-policy />
    </div>
    <div class="col-sm-12 mt-3">
      <message-info />
    </div>
    <div class="col-sm-12 mt-3">
      <input
        type="button"
        class="btn btn-fill btn-success btn-block btn-wd btn-md"
        name="verify"
        value="Verify"
        @click.prevent="verifyCode()"
      />
    </div>
    <div class="col-sm-12 mt-3 text-center">
       <p v-if="!showSkipStep">Didn't receive the code?</p>
      <p v-else>Haven't got your mobile with you?</p>
      <a href="#" @click.prevent="sendCode()" v-if="!showSkipStep">Send code again</a>
      <a href="#" @click.prevent="skipStep()" v-else>Still not received the code?</a>
    </div>
    </template>
    <template v-else>
    <Callback/>
    </template>
    <Loading v-if="loading" />
  </div>
  
</template>
<script>
var body = $("body");
function onKeyDown(e) {
  var key = e.which;
  if (
    key === 46 ||
    key === 37 ||
    key === 39 ||
    key === 8 ||
    key === 9 ||
    (key >= 48 && key <= 57) ||
    (key >= 96 && key <= 106)
  ) {
    return true;
  }

  e.preventDefault();
  return false;
}
body.on("keydown", ".input-code", onKeyDown);

import { mapGetters } from "vuex";
import mixin from "@/components/shared/mixinUtility";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import Loading from "@/components/ui/Loading.vue";
import Callback from "@/components/steps/Callback.vue";
import axios from "axios";
import PrivacyPolicy from '@/components/ui/PrivacyPolicy.vue';
export default {
  name: "VerifyCode",
  mixins: [mixin],
  data() {
    return {
      code: "",
      loading: false,
      showSkipStep:false,
      countSentCode:0,
      showCallback:false
    };
  },
  computed: {
    ...mapGetters({
      tabs: "getTabs",
      currentActive: "getCurrentActive",
      contactId: "getContactId",
      formData: "getFormData",
    }),
  },
  components: {
    "message-info": MessageInfo,
    Loading,
    Callback,
     "privacy-policy": PrivacyPolicy,
  },
  created() {
    this.$store.dispatch("setHideNavigation", true);
    this.$store.dispatch(
                    "setShowThankYouForYOH",
                    false
                  );
    this.resetMessageInfo();
  },
  methods: {
    resetMessageInfo() {
      this.$store.dispatch("setMessageInfo", {
        show: false,
        message: "",
        isSuccess: false,
      });
    },
    showGenericErrorMessage(message, success) {
      this.$store.dispatch("setMessageInfo", {
        show: true,
        message: message,
        isSuccess: success,
      });
    },
    sendCode() {
       this.countSentCode+=1;
      if (this.countSentCode==3)//show skip button
        this.showSkipStep=true;
      //send 2fa code to his mobile
      this.sendCodeToMobile(this.contactId);
    },
    verifyCode() {
      this.resetMessageInfo();
      this.$root.$validator
        .validate("step" + (this.currentActive + 1) + ".*")
        .then(async (valid) => {
          if (valid) {
            //send code and next step??
            if (await this.checkValidCode()) this.goNextStep();
          } else {
            //no
          }
        });
    },
    async checkValidCode() {
      this.loading = true;
      try {
        const { data } = await axios.post(
          process.env.VUE_APP_API_URL + "/client/Verify2FA",
          { contactId: this.contactId, code: parseInt(this.code) },
          { headers: { Authorization: `Bearer ${this.jwtToken}` } }
        );
        this.loading = false;
        return data.status == "OK";
      } catch (ex) {
        this.loading = false;
        this.showGenericErrorMessage(
          "Please check the code you've entered and try again.",
          false
        );
        return false;
      }
    },
    unverifyMobile() {
      try {
        axios.post(process.env.VUE_APP_API_URL + "/client/MobileUnVerify", {
          contactId: this.contactId,
        },
        { headers: { Authorization: `Bearer ${this.jwtToken}` } });
      } catch (ex) {
        console.log(ex);
      }
    },
    skipStep() {
      this.unverifyMobile();
      this.goNextStep();
    },
    goNextStep() {
      this.showCallback = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.code-container {
  display: flex;
}
.input-code {
  margin: 0 5px;
  text-align: center;
  line-height: 60px;
  font-size: 40px;
  border: solid 1px #ccc;
  box-shadow: 0 0 5px #ccc inset;
  outline: none;
  width: 100%;
  // width: 20%;
  transition: all 0.2s ease-in-out;
  border-radius: 3px;

  &:focus {
    border-color: purple;
    box-shadow: 0 0 5px purple inset;
  }

  &::selection {
    background: transparent;
  }
}
@media only screen and (max-width: 767.98px) {
  .input-code {
    line-height: 40px;
    font-size: 20px;
  }
}
</style>

